// extracted by mini-css-extract-plugin
export default {"container":"CheckoutSuccess_container__Mgwsf","content":"CheckoutSuccess_content__gjxV9","email":"CheckoutSuccess_email__joMik","more-info":"CheckoutSuccess_more-info__csSQs"};